export default "__VITE_ASSET__b1e9b2bb__"